import React, { useEffect, useRef} from 'react';
import styles from './flying-btn.module.scss';
import { Fade } from '../../animation/animation';

var x, y, PX = 5, PY = 5, ym = 600, xm = 600, followerW = 0, followerH = 0;

declare global {
	interface Window {
		msRequestAnimationFrame: typeof window.requestAnimationFrame;
		mozRequestAnimationFrame: typeof window.requestAnimationFrame;
		oRequestAnimationFrame: typeof window.requestAnimationFrame;
	}
}

// покадровая перерисовка
var stopIteration:boolean;
var iterationIsStarted:boolean;
function renderingLoop (callback?:Function) {
	if (iterationIsStarted) return;
	iterationIsStarted = true;
	stopIteration = false;

	iteration();

	function iteration() {
		if (stopIteration) {
			iterationIsStarted = false;
			return;
		}

		if (window.requestAnimationFrame)
	        window.requestAnimationFrame(iteration);
	    else if (window.msRequestAnimationFrame)
	        window.msRequestAnimationFrame(iteration);
	    else if (window.webkitRequestAnimationFrame)
	        window.webkitRequestAnimationFrame(iteration);
	    else if (window.mozRequestAnimationFrame)
	        window.mozRequestAnimationFrame(iteration);
	    else if (window.oRequestAnimationFrame)
	        window.oRequestAnimationFrame(iteration);
	   	callback && callback();	
	}
};

interface FlyingBtnProps {
	active: boolean
	onClick: (event:React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

export default function FlyingBtn({active, onClick}:FlyingBtnProps) {
	const cursorFollower = useRef<HTMLDivElement>(null);

	function mouseMove() {
		PX += ((xm - PX)*3)/200;
		PY += ((ym - PY)*3)/200;

		x = Math.round(PX);
		y = Math.round(PY);

		if (cursorFollower.current) {
			cursorFollower.current.style.left = x - followerW + "px";
			cursorFollower.current.style.top = y - followerH + "px";
		}
	}

	useEffect(() => {
		followerW = (cursorFollower?.current?.clientWidth || 0);
		followerH = (cursorFollower?.current?.clientHeight || 0)/2;
	}, [cursorFollower]);

	useEffect(() => {
		if (active) renderingLoop(mouseMove);
			else stopIteration = true;
	}, [active]);

	useEffect(() => {
		window.addEventListener('mousemove', (e:MouseEvent) => {
			xm = e.pageX;
			ym = e.pageY;
		})
	}, []);

	return (
		<Fade when={active}>
			<div onClick={onClick} ref={cursorFollower} className={styles.default}>Пройти <br/>тест</div>
		</Fade>
	);
}